export default {
      id: "planner-log-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#planner-log",
      toString: function () {
        return this.url;
      }
    }